module.exports = __webpack_public_path__ + "static/crb_logo1-4c9713b7efe63df549940972a4dbe01b.png";